import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAuthData } from '../../models';
import { CommonService } from '../common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ApiConstants, Constants } from '../../common';

@Injectable({
  providedIn: 'root',
})
export class Auth {

  constructor(private commonService: CommonService, private router: Router, private http: HttpClient) {

  }

  login(email: string, password: string): Observable<string> {
    const authData: IAuthData = { email, password };
    return new Observable<string>((observer) => {
      this.commonService.authenticate(authData).subscribe({
        next: (response) => {
          if (response && response.token) {
            localStorage.setItem(Constants.TOKEN_KEY, response.token);
            observer.next(response.message);
          } else {
            observer.error(response.message);
          }
          observer.complete();
        },
        error: (err: HttpErrorResponse) => {
          observer.error(err.error);
          observer.complete();
        },
      });
    });
  }

  logout() {
    this.commonService.clearToken().subscribe({
      next: () => {
        localStorage.removeItem(Constants.TOKEN_KEY);
        this.router.navigate([Constants.APP_ROUTES.login]);
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
        localStorage.removeItem(Constants.TOKEN_KEY);
        this.router.navigate([Constants.APP_ROUTES.login]);
      }
    })
  }

  get authenticated(): boolean {
    return !!localStorage.getItem(Constants.TOKEN_KEY);
  }

  generateToken(user_id: number): Observable<{ token: string }> {
    return this.http.get<{ token: string }>(`${ApiConstants.superAdminGenerateJwtToken}?user_id=${user_id}`);
  }
}
